import React, { useEffect, useState } from "react";
import ReactModal from "react-modal";
import apiCall from "../utils/api";
import Loader from "../components/Loader";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css"; // Import react-tabs styles
import "./Detail.css"; // Custom styles

ReactModal.setAppElement("#root"); // Important for accessibility

const Detail = () => {
  const [data, setData] = useState(null);
  const [surveyID, setSurveyID] = useState(null);
  const [loading, setLoading] = useState(false);
  const [surveyData, setSurveyData] = useState(null);

  useEffect(() => {
    const data = localStorage.getItem("userData");
    if (data) {
      let finalData = JSON.parse(data);
      setSurveyID(finalData?.surveyId);
      setData(finalData);
    }
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      fetchSurveyData();
    };
    fetchData();
  }, [surveyID]);

  const fetchSurveyData = async () => {
    try {
      setLoading(true);

      // Define both API calls
      const fetchTarget = apiCall({
        url:
          "https://supplier.innovatemr.net/api/v2/supply/getSurveyTargeting/" +
          surveyID,
        method: "GET",
      });

      const fetchQuota = apiCall({
        url:
          "https://supplier.innovatemr.net/api/v2/supply/getQuotaForSurvey/" +
          surveyID,
        method: "GET",
      });

      // Wait for both API calls to resolve
      const [response1, response2] = await Promise.all([
        fetchTarget,
        fetchQuota
          .then((response) => {
            // If the response is 404, return an empty array
            if (response.status === 404) {
              return { result: [] };
            }
            return response; // Return response for other status codes
          })
          .catch((error) => {
            // In case of any other error, return an empty array
            console.error("Error fetching quota data:", error);
            return { result: [] };
          }),
      ]);

      // Set the state with the results
      setSurveyData({
        target: response1.result,
        quota: response2.result || [],
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div>
      <Tabs>
        <TabList>
          <Tab>Target</Tab>
          <Tab>Links</Tab>
          <Tab>Quota</Tab>
        </TabList>

        <TabPanel>
          <div className="tab-content">
            <div className="response-container">
              <div className="question-card">
                <h6 className="question-text">
                  {"Project ID: " + surveyID + " - " + data?.Country}
                </h6>
              </div>
              <div className="question-card">
                <h6 className="question-text">
                  {"Langauage: " + data?.Language}
                </h6>
              </div>
              {surveyData?.target?.map((question, index) => (
                <div key={index} className="question-card">
                  <h6 className="question-text">{question?.QuestionText}</h6>
                  {question?.Options && question?.Options?.length > 0 && (
                    <div className="options-container">
                      <ul>
                        {question?.Options?.map((option, idx) => (
                          <li key={idx} className="option-item">
                            {option?.OptionText ||
                              `${option?.ageStart} - ${option?.ageEnd}`}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </TabPanel>

        <TabPanel>
          <div className="tab-content">
            <div className="question-card">
              <div className="links-container">
                <strong>Live Link: </strong>
                <a className="option-item">
                  {data?.entryLink?.replace("[%%pid%%]", "")}
                </a>
                <br />
                <strong>Test Link: </strong>
                <a className="option-item">
                  {data?.testEntryLink?.replace("[%%pid%%]", "")}
                </a>
              </div>
            </div>
          </div>
        </TabPanel>

        <TabPanel>
          <div className="tab-content">
            <div className="response-container">
              {surveyData?.quota?.map((quota, index) => (
                <div key={index} className="question-card">
                  <h6 className="question-text">
                    <span className="quota-name">
                      {"Quota Title: " + quota?.title}
                    </span>
                  </h6>
                  <div className="status">
                    <p>
                      <strong>Status:</strong>{" "}
                      <span
                        className={`status-${quota?.quotaStatus.toLowerCase()}`}
                      >
                        {quota?.quotaStatus}
                      </span>
                    </p>
                    <p>
                      <strong>Remaining:</strong>{" "}
                      <span className="quota-name">{quota?.RemainingN}</span>
                    </p>
                  </div>
                  <div className="targeting">
                    <p>
                      <strong>Targeting Age Range:</strong>
                    </p>
                    {quota?.targeting?.AGE?.map((ageRange, idx) => (
                      <div key={idx} className="age-range">
                        <ul>
                          <li className="option-item">
                            {ageRange?.ageStart} - {ageRange?.ageEnd}
                          </li>
                        </ul>
                      </div>
                    ))}
                  </div>
                  <div className="details">
                    <p>
                      <strong>Hard Stop:</strong>{" "}
                      {quota?.hardStop ? (
                        <span className="yes">Yes</span>
                      ) : (
                        <span className="no">No</span>
                      )}
                    </p>
                    <p>
                      <strong>Clicks:</strong> {quota?.clk}
                    </p>
                    <p>
                      <strong>Completes:</strong> {quota?.cmp}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </TabPanel>
      </Tabs>
    </div>
  );
};

export default Detail;
